<template>
	<div class="marker" v-bind:data-posx="position.x" v-bind:data-posy="position.y">
		<div class="x-mark">X</div>
		<div class="marker-label">{{label}}</div>
	</div>
</template>


<script>
	export default {
		props: ["position", "label"],
		mounted(){
			var mComp = this.$el;
			var x = mComp.getAttribute("data-posx");
			var y = mComp.getAttribute("data-posy");
			x = parseInt(x) + 55;
			mComp.style.top = x + "px";
			mComp.style.left = y + "px";

			this.$el.addEventListener("click", (e) => {
				e.srcElement.parentElement.classList.add("clicked-on");
			});
		}
	}
</script>


<style scoped>
	.marker{
		position: absolute;
		top: 0px;
		left: 0px;
		cursor: pointer;
	}
	.marker .x-mark{
		color: #DC0000;
		font-weight: bold;
		font-size: 1.4em;
	}
	.marker .marker-label{
		color: white;
		font-weight: bold;
		background: #000000aa;
		padding: 0 2px;
		border-radius: 5px;
		opacity: 0;
		transition: all 0.5S ease;
	}
	.clicked-on .marker-label{
		opacity: 1;
	}
</style>